<template>
    <v-group ref="group" :config="tokenConfig" @dragend="onDragend($event)">
        <v-image
            :name="entity.id"
            v-if="entity.token.image.asset"
            :config="imageConfig"
            @click="onClick()"
            @dblclick="onDoubleClick()"
        />
        <component
            v-else
            v-bind:is="shapeConfig.type"
            :config="shapeConfig.config"
            @click="onClick()"
            @dblclick="onDoubleClick()"
        />
        <ActionMenu
            @request-action-resolution="resolveAction"
            :gridSpace="gridSpace"
            v-if="selected"
            :actions="actions"
        ></ActionMenu>
        <v-text v-if="entity.counter" :config="counterConfig"></v-text>
    </v-group>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import ActionMenu from './ActionMenu';

export default {
    components: {
        ActionMenu: ActionMenu,
    },
    props: {
        gridSpace: {
            type: Object,
            required: true,
        },
        entity: {
            type: Object,
            required: true,
        },
        selectedProp: {
            type: Boolean,
            required: false,
        },
    },
    data: function() {
        return {
            showActionMenu: this.selectedProp,
            selected: this.selectedProp,
        };
    },
    computed: {
        ...mapGetters('gamestate/entities', {
            getEntityByRef: 'getEntityByRef',
        }),
        ...mapGetters('gamestate', {
            actions: 'actions',
        }),
        ...mapState('gamestate', {
            entities: 'entities',
        }),
        counterConfig() {
            return { text: this.entity.counter.toString(), fontSize: 40 };
        },
        // Config for v-group acting as token root
        tokenConfig() {
            return {
                draggable: true,
                position: this.gridSpace.gridToStage(this.entity.token.pos),
            };
        },
        imageConfig: function() {
            const token = this.entity.token;
            const image = token.image;
            const tokenSize = Math.floor(this.gridSpace.size);
            const asset = this.getEntityByRef(image.asset, this.entity).asset;

            let scale = tokenSize / Math.max(image.width, image.height);
            scale = scale * (token.size || 1);

            return {
                image: asset['@data'],
                width: image.width * scale,
                height: image.height * scale,
                offsetX: image.origin.x * scale,
                offsetY: image.origin.y * scale,
                stroke: 'white',
                strokeWidth: 15 * scale,
                strokeEnabled: this.selected,
            };
        },
        shapeConfig() {
            return {
                type: 'v-circle',
                config: {
                    radius: Math.floor(this.gridSpace.size / 2) - 1,
                    fill: this.entity.token.image.color || 'white',
                    stroke: 'white',
                    strokeEnabled: this.selected,
                },
            };
        },
    },
    methods: {
        onDragend() {
            this.$emit('moved', {
                position: this.$refs.group.getNode().position(),
                entity: this.entity,
            });
        },
        onClick() {
            this.showActions();
            this.selected = !this.selected;
            if (this.selected) {
                this.$emit('selected', {
                    entity: this.entity,
                });
            } else {
                this.$emit('deselected');
            }
        },
        onDoubleClick() {
            this.showActions();
            if (!this.selected) {
                this.selected = true;
                this.$emit('selected', {
                    entity: this.entity,
                });
            }
            this.$emit('dblclick', {
                character: this.entity,
            });
        },
        showActions() {
            this.showActionMenu = !this.showActionMenu;
        },
        resolveAction(action) {
            action.entity = this.entity;
            this.$store.dispatch('gamestate/resolveAction', action);
        },
    },
};
</script>
